import React, { useRef, useImperativeHandle, forwardRef } from 'react';

interface ChatInputProps {
  input: string;
  isLoading: boolean;
  apiHealthy: boolean;
  onSubmit: (e: React.FormEvent) => void;
  onInputChange: (value: string) => void;
  getContextualPlaceholder: () => string;
  t: any;
}

export interface ChatInputRef {
  focus: () => void;
}

const ChatInput = forwardRef<ChatInputRef, ChatInputProps>(({
  input,
  isLoading,
  apiHealthy,
  onSubmit,
  onInputChange,
  getContextualPlaceholder,
  t
}, ref) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useImperativeHandle(ref, () => ({
    focus: () => {
      inputRef.current?.focus();
    }
  }));

  return (
    <div className="border-t bg-white p-2 md:p-3 sm:p-4 lg:p-6 flex-shrink-0">
      <form onSubmit={onSubmit} className="flex space-x-2 md:space-x-3">
        <input
          ref={inputRef}
          type="text"
          value={input}
          onChange={(e) => onInputChange(e.target.value)}
          placeholder={isLoading ? t('chat.aiWorking') : getContextualPlaceholder()}
          disabled={isLoading || !apiHealthy}
          className={`flex-1 border border-gray-300 rounded-lg md:rounded-xl px-3 md:px-4 py-2 md:py-2.5 sm:py-3 text-sm md:text-base focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent transition-all min-h-[40px] md:min-h-[44px] ${
            isLoading || !apiHealthy
              ? 'bg-gray-100 text-gray-500 cursor-not-allowed'
              : 'bg-white'
          }`}
        />
        <button
          type="submit"
          disabled={!input.trim() || isLoading || !apiHealthy}
          className={`rounded-lg md:rounded-xl px-3 md:px-4 sm:px-6 py-2 md:py-2.5 sm:py-3 font-medium transition-all shadow-lg text-sm md:text-base min-h-[40px] md:min-h-[44px] min-w-[40px] md:min-w-[44px] ${
            !input.trim() || isLoading || !apiHealthy
              ? 'bg-gray-400 text-gray-600 cursor-not-allowed'
              : 'bg-gradient-to-r from-emerald-500 to-emerald-600 text-white hover:from-emerald-600 hover:to-emerald-700'
          }`}
        >
          {isLoading ? t('chat.loadingDots') : t('chat.send')}
        </button>
      </form>
    </div>
  );
});

export default ChatInput;